import { gql } from "@apollo/client";

export const CREATE_TYPEOF_EMPLOYMENT = gql`
  mutation createTypeOfEmployment($input: createTypeOfEmploymentInput) {
    createTypeOfEmployment(input: $input) {
      empId
    }
  }
`;

export const GET_TYPEOFEMPLOYMENT_BY_ORG = gql`
  query getTypeOfEmployments($orgId: Int) {
    getTypeOfEmployments(orgId: $orgId) {
      orgId
      name
      empId
      workingHours
      bufferTime
    }
  }
`;

export const DELETE_TYPEOFEMPLOYMENT = gql`
  mutation deleteTypeOfEmployment($empId: Int!, $orgId: Int) {
    deleteTypeOfEmployment(empId: $empId, orgId: $orgId)
  }
`;

export const UPDATE_TYPEOFEMPLOYMENT = gql`
  mutation updateTypeOfEmployment($input: updateTypeOfEmploymentInput) {
    updateTypeOfEmployment(input: $input)
  }
`;
export const GET_TYPEOFEMPLOYMENT_BY_ID = gql`
  query TypeOfEmploymentById($empId: Int) {
    TypeOfEmploymentById(empId: $empId) {
      empId
      name
      orgId
      workingHours
      bufferTime
    }
  }
`;
